








import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import { onRedirectPostMessage } from '@/app/commands/pagesCommands'

import PdfFormContainer from '@/components/pdfFormViewComponents/PdfFormContainer.vue'
import EmptyTransactionNotification from './EmptyTransactionNotification.vue'
import StatusPage from '@/components/StatusPage.vue'

@Component({
  name: 'SigningForm',
  components: {
    PdfFormContainer,
    EmptyTransactionNotification
  }
})
export default class SigningForm extends Vue {
  loading = true
  transactionLoadError = false

  get sessionId() { return this.$route.params.id }
  get senderId() { return this.$route.params.uid }

  async uploadTransaction() {
    try {
      const res = await this.$store.dispatch('uploadTransaction', {
        sessionId: this.sessionId,
        senderId: this.senderId,
      })  
      if (!res) this.transactionLoadError = true
    } catch (error) { this.transactionLoadError = true }
    finally {
      this.loading = false
    }
  }

  async created() {
    await this.uploadTransaction()
  }

  mounted() {
    // Редирект после оплаты картой
    onRedirectPostMessage(this.$router)({ id: this.sessionId, uid: this.senderId })
  }

  get currentStepComponent() {
    if (this.isPdfFormContainer()) return PdfFormContainer
    else return StatusPage
  }

  private isPdfFormContainer() {
    const status = this.$store.getters.transaction.status
    return status === 'Idle' // || status === 'AwaitingPayment'
  }
}
